// @flow
import styled from 'styled-components';

export const Form = styled.form`
  width: 100%;
  height: auto;
`;



// WEBPACK FOOTER //
// ./src/pages/sign-up/sign-up.styles.js